import React, { Component } from 'react'
import 'less/dashboard.less'
import Button from 'components/controls/button'
import {
  propEq,
  map,
  values,
  pipe,
  zip,
  identity,
  props,
  pathOr,
  path,
} from 'ramda'
import Modal from 'components/modal'
import { request } from 'shared/helpers/sagas'
import { connect } from 'react-redux'
import { fetchAllDashboardInfo, updateProjectModerators, toggleAddModeratorsModal, getUnavailableModerators, deleteProjectModerator, toggleTimeRangeModal, addModeratorTimeRange, toggleUnableToRemoveModModal } from 'store/project/projectActions'
import { localizedTranslate } from 'assets/localization'
import AddModeratorsModal from 'containers/dashboard/add-moderators-modal'
import ProjectAvailability from 'containers/scheduler/project-availability'
import AddManageRangeTimeModal from 'containers/dashboard/add-manage-time-range-modal'
import { Position, Tooltip } from "@blueprintjs/core";
import moment from 'moment' 
import { convert24to12Hours } from 'shared/helpers/functional'
import { localizedDateFormatter, getUserTimeZone} from 'assets/localization'
import UnableToRemoveModeratorModal from 'containers/dashboard/unable-to-remove-moderator-modal'
import { timezoneAbbreviationLabel } from 'shared/helpers/user'

class ProjectSidebar extends Component {
  state = {
    showFinalizeModal: false,
    isQSTool: window.location.href.indexOf("qstool") > -1,
    showAddModeratorsModal: false,
    moderatorToDelete: -1,
    projectSchedulingType: 'moderator',
    hasProjectWindows: false,
  }

  buildSummaryItems = pipe(
    props(['name', 'interviewLength', 'sampleSize']),
    zip([
      ['Project Name', identity],
      ['Interview Length', value => `${value} Minutes`],
      ['Sample Size', identity, true, "sample-size-button", () => this.props.openEditSampleSizeModal({
        projectId: this.props.currentProject.id,
        initialSampleSize: this.props.currentProject.sampleSize,
        completed: this.props.currentProject.completed,
        scheduled: this.props.currentProject.scheduled,
        showWarning: this.props.editSampleSizeModal.showWarning,
        avModCount: this.props.editSampleSizeModal.avModCount
      }), "EDIT"]]),
    map(([[title, f, editable, className, onClick, text], value]) => (
      <div className="summary-header-wrapper" key={title}>
        <div className="summary-header">{title}</div>
        {editable ? <div className='value-edit-wrapper'><div>{f(value)}</div><div className={className}>
          <button className="btn btn-primary" onClick={onClick}>
            <i className="im-edit" /><span>{text}</span>
          </button>
        </div></div> : <div>{f(value)}</div>}
      </div>
    ))
  )

  buildClientScreenInformation = pipe(
    props(['salesForceAccountName', 'salesForceJobNumber', 'externalSurveyId']),
    zip([
      ['Client', identity],
      ['Salesforce Job Number', identity],
      ['Survey ID', identity, true, "edit-surveyId-button", () => this.props.openEditSurveyIdModal(), "EDIT"]
    ]),
    map(([[title, f, editable, className, onClick, text], value]) => (
      <div className="summary-header-wrapper" key={title}>
        <div className="summary-header">{title}</div>
        {editable ? <div className='value-edit-wrapper'><div>{f(value)}</div><div className={className}>
          <button className="btn btn-primary" onClick={onClick}>
            <i className="im-edit" /><span>{text}</span>
          </button>
        </div></div> : <div>{f(value)}</div>}
      </div>
    ))
  )

  buildAdvancedOptions = pipe(
    props(['postScreeninBuffer','moderatorBuffer']),
    zip([
      ['Interview Time Buffer', value => `${value} Hours`, true, "post-screenin-button", () => this.props.openEditInterviewOrModeratorBufferModal({'flag' : 'postScreeninBuffer' }), "EDIT"],
    ]),
    map(([[title, f, editable, className, onClick, text], value]) => (
      <div className="summary-header-wrapper" key={title}>
        <div className="summary-header">{title}</div>
        {editable ? <div className='value-edit-wrapper'><div>{f(value)}</div><div className={className}>
          <button className="btn btn-primary" onClick={onClick}>
            <i className="im-edit" /><span>{text}</span>
          </button>
        </div></div> : <div>{f(value)}</div>}
      </div>
    ))
  )


  finalizeProject = () => {
    this.setState({ isFinalizing: true })

    request(
      `/v1/project/${this.props.currentProject.id}/finalize`,
      'PUT',
      {}
    ).then(({ project, surveys }) => {
      this.setState({
        isFinalizing: false,
        showFinalizeModal: false,
      })
      this.props.fetchAllDashboardInfo(this.props.currentProject.id)
      this.props.finalizeProjectSucceeded({ ...project, surveys })
    }).catch(() => {
      this.setState({ isFinalizing: false })
      this.props.finalizationErrorWarning()
    })

  }
  reOpenProject = () => {
    this.setState({ isReopening: true })

    request(
      `/v1/project/${this.props.currentProject.id}/reopen`,
      'PUT',
      {}
    ).then(({ project, surveys }) => {
      this.setState({
        isReopening: false,
        showReOpenModal: false,
      })
      this.props.fetchAllDashboardInfo(this.props.currentProject.id)
      this.props.reOpenProjectSucceeded({ ...project, surveys })
    }).catch(() => {
      this.setState({ isReopening: false })
      this.props.reOpeningErrorWarning()
    })

  }

  toggleFinalizeModal = () => {
    this.setState({ showFinalizeModal: !this.state.showFinalizeModal })
  }

  toggleReOpenModal = () => {
    this.setState({ showReOpenModal: !this.state.showReOpenModal })
  }

  copyLinkAction = () => {
    navigator.clipboard.writeText(this.props.currentProject.generatedLink)
    this.props.showSnackbarMessage("Scheduler link copied to clipboard.")
    this.props.hideSnackbarMessage()
  }

  deleteModeratorInProject = (moderatorId) => {
    this.props.deleteProjectModerator({moderatorId:moderatorId, flag:'single', clientId: this.props.clientId} )
    this.setState({
      moderatorToDelete: -1,
    });
  }
  showDeleteBtn = (moderatorId) => {
    this.setState({
      moderatorToDelete: moderatorId,
    });
  }

  render() {
    const projectIsComplete = propEq('projectStatusId', 4, this.props.currentProject)
    const projectIsFinalizing = propEq('projectStatusId', 7, this.props.currentProject)
    const projectIsDefining = propEq('projectStatusId', 1, this.props.currentProject)
    const availableModerators = pipe(pathOr({}, ['currentProject', 'dashboardInfo', 'moderatorInfo']), values)(this.props)
    const buildAvailableModerators = map(({ firstName, lastName, id, clientId, interviewCount, startTime, endTime, timezone }) => {
      return (
        <div key={id} className="available-moderator-info">
          <div className="moderator-container">
            <div className="icon-background">
              <div className="im-user2" />
            </div>
            <div>
              <div className="moderator-name">{firstName} {lastName}</div>
              <div>Moderator #{id}</div>
              <div className={`manage-moderator-button`}>
                <Button className="manage-moderator-btn btn-primary"
                  onClick={() => {
                    this.props.setSingleModerator({ id: id, clientId: clientId, label: `${firstName} ${lastName}` })
                    this.props.history.push(`/moderatorManagement/schedule`)
                  }}
                > Manage Moderator
                </Button>
              </div>
              <div className={`time-range-button ${(startTime || startTime === 0) ? 'time-defined' : ''} ${!projectIsDefining ? 'disabled' : ''}`}>
                {
                  <Button className="time-range-btn btn-primary"
                   onClick={() => this.props.toggleTimeRangeModal({ moderatorId: id, selectedModeratorTimeRange: { startTime: startTime, endTime: endTime, timezone: timezone? timezone : this.props.userTimeZone } })}
                    disabled={!projectIsDefining}
                  >
                    <i className={` ${(startTime || startTime === 0) ? 'im-edit' : ''}`} />
                    {(startTime || startTime === 0) ?
                      convert24to12Hours(startTime) + ' - ' + convert24to12Hours(endTime) + ' ' + (timezoneAbbreviationLabel(timezone))
                      :
                      'Add Time Range (Optional)'}
                  </Button>
                }
                <Tooltip popoverClassName={"add-moderators-tooltip"}
                  content={this.props.t("add.time.range.tooltip.message")}
                  position={Position.BOTTOM}
                  className={`time-range-tooltip ${(startTime || startTime === 0) ? 'time-defined' : ''}`}
                >
                  <p className='im-help'></p>
                </Tooltip>
              </div>
            </div>
          </div>
          <div className="interview-count">
            {interviewCount} INTERVIEWS
          </div>
          <div className="trash-logo-container">
            <button className={'im-trash'} onClick={() => this.showDeleteBtn(id)} />
            {this.state.moderatorToDelete == id &&
              <button id={`del-mod-${id}`} className="remove-moderator-btn" onClick={() => this.deleteModeratorInProject(id)}>{this.props.t('remove.moderator')}</button>}
          </div>
        </div>)
    })
    // In project-timeslots mode the link is gated on having at least one project window
    // (not on assigned moderators, which project mode doesn't use).
    const isProjectMode = this.state.projectSchedulingType === 'project'
    const enableGenerateSchedulerButton = isProjectMode
      ? this.state.hasProjectWindows
      : (this.props.currentProject.dashboardInfo && this.props.currentProject.dashboardInfo.moderatorInfo && this.props.currentProject.dashboardInfo.moderatorInfo[0])
    const showTooltip = isProjectMode
      ? !this.state.hasProjectWindows
      : !this.props.currentProject.dashboardInfo.moderatorInfo[0]

    return (
      <div className="project-dashboard-sidebar-container">
        <div className="project-dashboard-sidebar-header">SCHEDULER LINK</div>
        <div className="line" />
        <div className="project-dashboard-sidebar-header-content">
          {this.props.t('scheduler.link.message')}
        </div>
        {!this.props.currentProject.showGenerateSchedulerLink ?
          <div>
            <Tooltip popoverClassName={"add-moderators-tooltip"}
              content={showTooltip ? (isProjectMode ? 'Add at least one project timeslot to generate the link.' : this.props.t('no.moderators.selected.message')) : ''}
              position={Position.TOP}
            >
              <Button className={`generate-scheduler-link btn-primary ${enableGenerateSchedulerButton ? '' : "disabled"}`}
                onClick={() => this.props.getUnavailableModerators({ id: this.props.currentProject.id })}
                isLoading={this.props.currentProject.isSubmitting}
              >{this.props.t('generate.scheduler.link')}
              </Button>
            </Tooltip>
          </div>
          :
          <div className="scheduler-link-info-wrapper">
            <div className="scheduler-link-info">
              <div className="scheduler-link-container">
                <div>
                  <div className="scheduler-link"> {this.props.currentProject.generatedLink} </div>
                </div>
              </div>
            </div>
            <Button className="copy-link btn-primary" onClick={this.copyLinkAction}> Copy Scheduler Link</Button>
          </div>
        }
        <ProjectAvailability
          projectId={this.props.currentProject.id}
          user={this.props.user}
          userTimeZone={this.props.schedulerTimeZone || this.props.userTimeZone}
          updateTimeZone={this.props.updateTimeZone}
          t={this.props.t}
          formatDate={this.props.formatDate}
          showMessage={this.props.showSnackbarMessage}
          hideMessage={this.props.hideSnackbarMessage}
          onSchedulingTypeChange={(mode) => { this.setState({ projectSchedulingType: mode }); this.props.setProjectSchedulingType(mode) }}
          onWindowsChange={(hasBookableSlot) => this.setState({ hasProjectWindows: !!hasBookableSlot })}
        />
        {this.state.projectSchedulingType !== 'project' &&
          <React.Fragment>
            <div className="line" />
            <div className="project-dashboard-sidebar-header">Available Moderators</div>
            <div className="line" />
            <div className="list-moderators-msg">{this.props.t('moderators.list.message')}</div>
            {availableModerators.length ?
              <div className="moderators-dashboard-header">
                <div className="moderators-header">
                  <div className="name-label">Name & ID</div>
                  <div className="interview-count-label">Interviews for this project</div>
                </div>
                {buildAvailableModerators(availableModerators)}
              </div>
              :
              <div className="project-controls">
                {/* <div className="line" />
                <button className="btn btn-primary" onClick={() => this.props.history.push('/moderator/schedule')}>
                <div className="edit-button"><i className="im-ss-clock" />Add My Availability</div>
                </button> */}
                <div className="add-moderators-section">
                  <div className="add-moderators-icon">
                    <span className="moderator-add"></span>
                  </div>
                  <div className="add-moderators-text">
                    {this.props.t('add.moderators.message')}
                  </div>
                  <Button className="add-moderators-btn btn-primary" onClick={this.props.toggleAddModeratorsModal}> Add/Manage Moderators</Button>
                </div>
              </div>
            }
            {availableModerators.length !== 0 &&
              <Button className="add-moderators-btn-2 btn-primary" onClick={this.props.toggleAddModeratorsModal}> Add/Manage Moderators</Button>
            }
          </React.Fragment>
        }
        <div className="project-dashboard-sidebar-header">PROJECT INFORMATION</div>
        <div className="line" />
        {this.buildSummaryItems(this.props.currentProject)}
        <div className="project-dashboard-sidebar-header">CLIENT & SCREENER INFORMATION</div>
        <div className="line" />
        {this.buildClientScreenInformation(this.props.currentProject)}
        <div className="project-dashboard-sidebar-header">ADVANCED OPTIONS</div>
        <div className="line" />
        {this.buildAdvancedOptions(this.props.currentProject)}
        {/* {!this.state.isQSTool &&
              <div>
                <div className="project-dashboard-sidebar-header">Finalize & Close Project</div>
                <div className="line" />
                <p>
                  Finalize and close this project if you no longer require additional interviews.
                  The finalizing process will take <b>72 hours</b> to ensure accuracy,
                  process transcriptions, and finalize billing.
                </p>
                <div className="project-controls">
                  <button className="btn btn-primary finalize" onClick={this.toggleFinalizeModal}>
                    <div className="edit-button"><i className="im-cancel-circle2" />Finalize & Close Project</div>
                  </button>
                </div>
              </div>
            } */}
        {/* </div>
        } */}
        {!this.state.isQSTool && (projectIsComplete || projectIsFinalizing) &&
          <div className="project-controls">
            <button className="btn btn-primary" onClick={() => this.props.history.push(`review`)}>
              <div className="edit-button">View Project Details</div>
            </button>
            <div>
              <div className="project-dashboard-sidebar-header">Re-Open Project</div>
              <div className="line" />
              <p>
                This will set your project back to In Progress.
              </p>
              <div className="project-controls">
                <button className="btn btn-primary reopen" onClick={this.toggleReOpenModal}>
                  <div className="edit-button">Re-Open Project</div>
                </button>
              </div>
            </div>
          </div>
        }
        {Boolean(this.state.showFinalizeModal) &&
          <Modal
            isOpen={this.state.showFinalizeModal}
            className="confirmation-modal finalization-modal"
            type="dialog"
            autoFocusSubmit={false}
            submitBtnText="Confirm"
            onCancel={this.toggleFinalizeModal}
            onSubmit={this.finalizeProject}
            isSubmitting={this.state.isFinalizing}
          >
            <div className="finalize-modal-body">
              <i className="im-warning" />
              <div className="finalize-modal-text">
                <p>
                  Finalizing this project will stop interview recruitment, the project <b>will no longer be
                    able to field interviews</b> and you will be unable to edit details. The finalizing process
                  will take <b>72 hours</b> to ensure accuracy, process transcriptions, and finalize billing.
                </p>
                <p>
                  All interviews that are currently scheduled for this project will be cancelled.
                  <b> Any interviews scheduled to be completed within 24 hours of initiating finalization, will
                    also have their full honoraria billed to your account.</b>
                </p>
                <p>
                  Are you sure you want to finalize and close?
                </p>
              </div>
            </div>
          </Modal>}
        {Boolean(this.state.showReOpenModal) &&
          <Modal
            isOpen={this.state.showReOpenModal}
            className="confirmation-modal finalization-modal"
            type="dialog"
            autoFocusSubmit={false}
            submitBtnText="Confirm"
            onCancel={this.toggleReOpenModal}
            onSubmit={this.reOpenProject}
            isSubmitting={this.state.isReOpening}
          >
            <div className="finalize-modal-body">
              <i className="im-warning" />
              <div className="finalize-modal-text">
                <p>
                  Your project status will return to In Progress. Do you wish to proceed?
                </p>
              </div>
            </div>
          </Modal>}
        {Boolean(this.props.showAddModeratorsModal) &&
          <AddModeratorsModal
            title={"ADD MODERATORS"}
            isOpen={this.props.showAddModeratorsModal}
            className="confirmation-modal add-moderators-modal"
            type="modal"
            autoFocusSubmit={false}
            submitBtnText="Add Link"
            onCancel={this.props.toggleAddModeratorsModal}
            onSubmit={this.showConferenceLink}
            enableSubmit={this.state.enableSubmit}
            isSubmitting={this.props.isSubmitting}
            clientId={this.props.clientId}
            t={this.props.t}
            projectId={this.props.currentProject.id}
            toggleAddModeratorsModal={this.props.toggleAddModeratorsModal}
            addModeratorsMessage={this.props.addModeratorsMessage}
            hideSnackbarMessage={this.props.hideSnackbarMessage}
            updateProjectModerators={this.props.updateProjectModerators}
            moderatorList={this.props.moderatorList}
            noModerators={this.props.noModerators}
            fetchModerators={this.props.fetchModerators}
            moderatorsScheduledInterviews={this.props.moderatorsScheduledInterviews}
            modifiedModerators={this.props.modifiedModerators}
            defaultModerators={this.props.defaultModerators}
            status={this.props.status}
            defaultModeratorsDetails={this.props.defaultModeratorsDetails}
            messageKey={this.props.messageKey}
          />
        }
        <AddManageRangeTimeModal
          isOpen={this.props.showTimeRangeModal}
          className="confirmation-modal add-manage-time-range-modal"
          onCancel={this.props.toggleTimeRangeModal}
          onSubmit={this.props.addModeratorTimeRange}
          isSubmitting={this.props.timeRangeSubmitting}
          t={this.props.t}
          projectId={this.props.currentProject.id}
          moderatorId={this.props.moderatorId}
          selectedModeratorTimeRange={this.props.selectedModeratorTimeRange}
          avModerators = {this.props.currentProject.dashboardInfo.moderatorInfo}
          userTimeZone={this.props.userTimeZone}
        />
        <UnableToRemoveModeratorModal
          isOpen={this.props.showUnableToRemoveModModal}
          className="confirmation-modal unable-to-remove-moderator-modal"
          onCancel={this.props.toggleUnableToRemoveModModal}
          t={this.props.t}
          userTimeZone={this.props.userTimeZone}
          moderatorsScheduledInterviews={this.props.moderatorsScheduledInterviews}
          showUnableToRemoveModErrorMessage={this.props.showUnableToRemoveModErrorMessage}
          showCancelBtn={false}
          formatDate={this.props.formatDate}
          flag={this.props.flag}
          toggleAddModeratorsModal={this.props.toggleAddModeratorsModal}
          modifiedModerators={this.props.modifiedModerators}
          defaultModerators={this.props.defaultModerators}
          status={this.props.status}
          defaultModeratorsDetails={this.props.defaultModeratorsDetails}
          clientId={this.props.clientId}
          messageKey={this.props.messageKey}
          setSingleModerator={this.props.setSingleModerator}
          history={this.props.history}
          /> 
      </div>
    )
  }
}

const mapDispatch = {
  finalizationErrorWarning: () => ({
    type: "SHOW_MESSAGE", payload: { message: "There was an error finalizing your project" },
  }),
  reOpeningErrorWarning: () => ({
    type: "SHOW_MESSAGE", payload: { message: "There was an error re-opening your project" },
  }),
  finalizeProjectSucceeded: (payload) => ({ type: "FINALIZE_PROJECT_SUCCEEDED", payload }),
  reOpenProjectSucceeded: (payload) => ({ type: "REOPEN_PROJECT_SUCCEEDED", payload }),
  fetchAllDashboardInfo,
  updateProjectModerators,
  toggleAddModeratorsModal,
  deleteProjectModerator,
  getUnavailableModerators,
  toggleTimeRangeModal,
  addModeratorTimeRange,
  toggleUnableToRemoveModModal,
  fetchModerators: payload => ({ type: 'FETCH_ALL_MODERATORS_REQUESTED', payload }),
  setSingleModerator: payload => ({type:'SET_SINGLE_MODERATOR', payload}),
  updateTimeZone: payload => ({ type: 'SET_SCHEDULER_TIMEZONE', payload }),
  setProjectSchedulingType: payload => ({ type: 'SET_PROJECT_SCHEDULING_TYPE', payload })
}

function mapStateToProps(state) {
  return {
    t: localizedTranslate('en', state.translations.en_us),
    clientId: state.client.clientId,
    showAddModeratorsModal: state.currentProject.showAddModeratorsModal,
    showTimeRangeModal: state.currentProject.showTimeRangeModal,
    showUnableToRemoveModModal: state.currentProject.showUnableToRemoveModModal,
    isSubmitting: state.currentProject.isSubmitting,
    moderatorList: state.moderatorList.moderatorList,
    noModerators: state.moderatorList.noModerators,
    moderatorId: state.currentProject.moderatorId,
    selectedModeratorTimeRange: state.currentProject.selectedModeratorTimeRange, 
    timeRangeSubmitting: state.currentProject.timeRangeSubmitting,
    formatDate: localizedDateFormatter('en', getUserTimeZone(state)),
    userTimeZone: getUserTimeZone(state),
    schedulerTimeZone: state.scheduler.selectedTimeZone,
    moderatorsScheduledInterviews: state.currentProject.moderatorsScheduledInterviews,
    showUnableToRemoveModErrorMessage: state.currentProject.showUnableToRemoveModErrorMessage,
    flag:  state.currentProject.flag,
    modifiedModerators: state.currentProject.modifiedModerators,
    defaultModerators: state.currentProject.defaultModerators,
    status: state.currentProject.status,
    defaultModeratorsDetails: state.currentProject.defaultModeratorsDetails,
    messageKey: state.currentProject.messageKey
  }
}

export default connect(mapStateToProps, mapDispatch)(ProjectSidebar)
